import Helmet from "react-helmet";
import { Outlet, Route } from "react-router";
import styled, { createGlobalStyle } from "styled-components";

import Brands from "./pages/Brands";
import CreateBrand from "./pages/CreateBrand";
import EditBrand from "./pages/EditBrand";
import AppHeader from "../../components/AppHeader";
import {
    useUnsavedChangesRefs,
    type UnsavedChangesContext,
} from "../../modules/unsaved-changes";

const GlobalStyle = createGlobalStyle`
    :root {
    }
`;

const Styled = styled.div`
    display: grid;
    grid-template-columns: 1fr 3fr;
    gap: 4vw;
    padding: 128px 128px 64px 192px;

    & > *:not(:last-child):not(:hover):not(:has(input:focus)) {
        opacity: .4;
    }
`;

function App() {
    const guard = useUnsavedChangesRefs();

    return (
        <>
            <Helmet>
                <title>Brands</title>
            </Helmet>
            <GlobalStyle />
            <AppHeader title="brands" guard={ guard } />
            <Styled>
                <Outlet context={ guard satisfies UnsavedChangesContext } />
            </Styled>
        </>
    );
}

export default (
    <Route Component={ App } path="brands">
        <Route Component={ Brands }>
            <Route index />
            <Route Component={ CreateBrand } path="new" />
            <Route Component={ EditBrand } path=":brandID" />
        </Route>
    </Route>
);
